<template>
  <section class="section">
    <div class="container">
      <h1 class="title">Control de asistencia</h1>
      <p class="subtitle">Marca y consulta la asistencia del grupo seleccionado.</p>

      <div class="box main-control">
        <div class="field is-horizontal">
          <div class="field-body">
            <div class="field">
              <label class="label">Fecha</label>
              <div class="field has-addons">
                <div class="control">
                  <input class="input" type="date" v-model="fecha" @change="onFechaChange" />
                </div>
                <div class="control">
                  <button class="button is-small" type="button" @click="irAHoy">Actualizar días</button>
                </div>
              </div>
            </div>
            
          </div>
        </div>

        <div v-if="!grupoNombre" class="notification is-warning">Selecciona un grupo para gestionar asistencias.</div>

        <div v-else>
          <div class="box">
            <div class="field is-grouped is-grouped-multiline desktop-action-row">
              <div class="control">
                <button
                  v-if="isEditMode"
                  class="button is-primary is-small"
                  :class="{ 'is-loading': isSaving }"
                  :disabled="!isDirty || isSaving"
                  @click="guardarMensual"
                >
                  Guardar asistencia
                </button>
                <button
                  v-else
                  class="button is-info is-small"
                  :disabled="isSaving"
                  @click="activarEdicion"
                >
                  Editar asistencia
                </button>
              </div>
              <div class="control">
                <span class="tag" :class="isEditMode ? 'is-warning' : 'is-success'">
                  {{ isEditMode ? 'Modo edición' : 'Modo consulta' }}
                </span>
              </div>
            </div>

              <div style="display:flex; gap:8px; align-items:center; justify-content:space-between;">
                <div class="month-title" style="flex:1">{{ monthTitle }}</div>
                <div style="flex:0; display:flex; gap:6px;">
                  <button class="button is-small is-success is-light" @click="exportarExcel">
                    Exportar Excel
                  </button>
                  <button class="button is-small" @click="showDesdeHoy = !showDesdeHoy">
                    {{ showDesdeHoy ? 'Mostrar todo el mes' : 'Mostrar desde hoy' }}
                  </button>
                </div>
              </div>

              <div class="resumen-general-grid">
                <div v-for="item in resumenGeneralItems" :key="item.key" class="resumen-card">
                  <div class="resumen-card-label">{{ item.label }}</div>
                  <div class="resumen-card-value">{{ item.attended }} <small>de {{ item.possible }}</small></div>
                </div>
              </div>

            <div class="table-scroll">
              <table class="table is-fullwidth is-striped is-narrow monthly-table">
                <thead>
                  <tr>
                    <th>Miembro</th>
                    <th v-for="d in diasVisible" :key="d.day" :class="{ 'dia-domingo': d.dow===0, 'dia-jueves': d.dow===4, 'dia-par': (d.day % 2)===0 }">
                      {{ d.day }}<br/><small>{{ d.nombre }}</small>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="m in miembros" :key="m.id">
                    <td class="member-name-cell">
                      <span class="member-name-text" :title="m.nombre">{{ m.nombre }}</span>
                    </td>
                    <td v-for="d in diasVisible" :key="d.day" :class="{ 'dia-domingo': d.dow===0, 'dia-jueves': d.dow===4, 'dia-par': (d.day % 2)===0 }">
                      <div style="display:flex; gap:6px; align-items:center;">
                        <div
                          v-for="(slot, idx) in slotsForDay(d)"
                          :key="idx"
                          class="slot-box"
                          :class="{ 'is-present': isSlotPresent(m.id, d.day, idx), 'is-edited': isEditMode && isSlotEdited(m.id, d.day, idx) }"
                          :title="`${slot.label} ${slot.hora}`"
                        >
                          <label class="checkbox" style="display:block;">
                            <input
                              class="asistencia-check"
                              :class="{ 'is-edited-check': isEditMode && isSlotEdited(m.id, d.day, idx) }"
                              type="checkbox"
                              :disabled="slot.disabled || !isEditMode"
                              v-model="matrixMonthly[m.id][d.day][idx]"
                              @change="onCheckboxChange"
                            >
                          </label>
                          <div class="slot-label">{{ slot.label }}</div>
                          <div class="slot-hora">{{ slot.hora }}</div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="resumen-miembros-wrap">
              <h3 class="subtitle is-6 resumen-miembros-title">Resumen mensual por miembro</h3>
              <div class="table-container">
                <table class="table is-fullwidth is-narrow is-hoverable resumen-miembros-table">
                  <thead>
                    <tr>
                      <th>Miembro</th>
                      <th>5:00</th>
                      <th>9:00</th>
                      <th>19:00</th>
                      <th>Servicio especial</th>
                      <th>Dominical 7:00</th>
                      <th>Total general</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="r in resumenPorMiembro" :key="r.id">
                      <td>{{ r.nombre }}</td>
                      <td>{{ formatCounter(r.oracion5) }}</td>
                      <td>{{ formatCounter(r.oracion9) }}</td>
                      <td>{{ formatCounter(r.oracion19) }}</td>
                      <td>{{ formatCounter(r.especial) }}</td>
                      <td>{{ formatCounter(r.dominical7) }}</td>
                      <td><strong>{{ formatCounter(r.total) }}</strong></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="mobile-fab-actions">
              <button
                v-if="isEditMode"
                class="button is-primary is-small mobile-fab-button"
                :class="{ 'is-loading': isSaving }"
                :disabled="!isDirty || isSaving"
                @click="guardarMensual"
              >
                Guardar
              </button>
              <button
                v-else
                class="button is-info is-small mobile-fab-button"
                :disabled="isSaving"
                @click="activarEdicion"
              >
                Editar
              </button>
            </div>
          </div>
          
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import HttpService from '@/Servicios/HttpService'

export default {
  name: 'ControlAsistencia',
  data(){
    return {
      fecha: new Date().toISOString().substr(0,10),
      grupoNombre: localStorage.getItem('grupoSeleccionadoNombre') || '',
      grupoSeleccionadoId: Number(localStorage.getItem('grupoSeleccionado') || 0) || null,
      miembros: [],
      servicios: [],
      matrix: {},
      diasMes: [],
      matrixMonthly: {},
      servicesByDay: {},
      showDesdeHoy: true,
      startDesdeDia: null,
      isEditMode: true,
      isSaving: false,
      isDirty: false,
      lastSavedSnapshot: '',
      resumenVersion: 0
    }
  },
    computed: {
      monthTitle(){
        try{
          const [y, m] = this.fecha.split('-').map(Number)
          const meses = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre']
          const mesNombre = meses[(m || (new Date().getMonth()+1)) - 1] || ''
          const anio = y || new Date().getFullYear()
          return mesNombre + ' ' + anio
        }catch(e){ return this.fecha }
      },
      diasVisible(){
          if(!this.diasMes || !this.diasMes.length) return []
          const today = new Date()
          const [y, m] = this.fecha.split('-').map(Number)
          let start = 1
          if(this.showDesdeHoy){
            const sameYear = (y || today.getFullYear()) === today.getFullYear()
            const sameMonth = (m ? m - 1 : today.getMonth()) === today.getMonth()
            if(sameYear && sameMonth) start = today.getDate()
          } else if(this.startDesdeDia){
            start = Number(this.startDesdeDia) || 1
          }
          return this.diasMes.filter(d => d.day >= start)
      },
      resumenData(){
        // Fuerza recálculo inmediato cuando cambia un checkbox en estructuras profundas.
        void this.resumenVersion
        const crear = () => ({ attended: 0, possible: 0 })
        const crearContadores = () => ({
          oracion5: crear(),
          oracion9: crear(),
          oracion19: crear(),
          especial: crear(),
          dominical7: crear(),
          total: crear()
        })

        const general = crearContadores()
        const miembrosMap = {}
        for(const m of this.miembros){ miembrosMap[m.id] = crearContadores() }

        for(const d of this.diasMes){
          const slots = this.slotsForDay(d)
          for(let idx = 0; idx < slots.length; idx++){
            const slot = slots[idx]
            const categoria = this.slotCategory(slot)
            if(!categoria) continue

            for(const m of this.miembros){
              const memberCounters = miembrosMap[m.id]
              memberCounters[categoria].possible += 1
              memberCounters.total.possible += 1
              general[categoria].possible += 1
              general.total.possible += 1

              const presente = this.matrixMonthly[m.id] && this.matrixMonthly[m.id][d.day]
                ? Number(this.matrixMonthly[m.id][d.day][idx] ? 1 : 0)
                : 0
              if(!presente) continue

              memberCounters[categoria].attended += 1
              memberCounters.total.attended += 1
              general[categoria].attended += 1
              general.total.attended += 1
            }
          }
        }

        return { general, miembrosMap }
      },
      resumenGeneralItems(){
        const g = this.resumenData.general
        return [
          { key: 'oracion5', label: 'Oración 5:00', ...g.oracion5 },
          { key: 'oracion9', label: 'Oración 9:00', ...g.oracion9 },
          { key: 'oracion19', label: 'Oración 19:00', ...g.oracion19 },
          { key: 'especial', label: 'Servicio especial', ...g.especial },
          { key: 'dominical7', label: 'Dominical 7:00', ...g.dominical7 },
          { key: 'total', label: 'Total general', ...g.total }
        ]
      },
      resumenPorMiembro(){
        const mapa = this.resumenData.miembrosMap
        return this.miembros.map(m => ({
          id: m.id,
          nombre: m.nombre,
          oracion5: mapa[m.id] ? mapa[m.id].oracion5 : { attended: 0, possible: 0 },
          oracion9: mapa[m.id] ? mapa[m.id].oracion9 : { attended: 0, possible: 0 },
          oracion19: mapa[m.id] ? mapa[m.id].oracion19 : { attended: 0, possible: 0 },
          especial: mapa[m.id] ? mapa[m.id].especial : { attended: 0, possible: 0 },
          dominical7: mapa[m.id] ? mapa[m.id].dominical7 : { attended: 0, possible: 0 },
          total: mapa[m.id] ? mapa[m.id].total : { attended: 0, possible: 0 }
        }))
      },
      snapshotMatrix(){
        try{
          return this.lastSavedSnapshot ? JSON.parse(this.lastSavedSnapshot) : {}
        } catch(_e){
          return {}
        }
      }
    },
  created(){
    this._onGrupoChanged = () => {
      this.grupoNombre = localStorage.getItem('grupoSeleccionadoNombre') || ''
      this.grupoSeleccionadoId = Number(localStorage.getItem('grupoSeleccionado') || 0) || null
      this.cargarMiembros()
      this.cargarServiciosYAsistencias()
    }
    window.addEventListener('grupoSeleccionadoChanged', this._onGrupoChanged)
    // Si hay un grupo seleccionado en localStorage, usarlo; si no, intentar obtener el grupo asignado al usuario (jefe)
    const gNombre = localStorage.getItem('grupoSeleccionadoNombre') || ''
    if(gNombre){
      this.grupoNombre = gNombre
      this.cargarMiembros()
      this.cargarServiciosYAsistencias()
    } else {
      this.determinarGrupoDefault()
    }
  },
  beforeDestroy(){ window.removeEventListener('grupoSeleccionadoChanged', this._onGrupoChanged) },
  methods: {
    onFechaChange(){
      // Cuando el usuario selecciona una fecha, posicionar la vista en ese día
      const partes = (this.fecha || '').split('-')
      const dia = partes.length === 3 ? Number(partes[2]) : null
      this.startDesdeDia = dia || null
      this.showDesdeHoy = false
      this.generarDiasMes()
      this.cargarServiciosYAsistencias()
    },
    irAHoy(){
      const hoy = new Date()
      const yyyy = hoy.getFullYear()
      const mm = String(hoy.getMonth() + 1).padStart(2, '0')
      const dd = String(hoy.getDate()).padStart(2, '0')
      this.fecha = `${yyyy}-${mm}-${dd}`
      this.onFechaChange()
      // asegurar que la vista se muestre desde hoy
      this.showDesdeHoy = true
    },
    async determinarGrupoDefault(){
      try{
        const ses = (await import('@/Servicios/AyudanteSesion')).default.obtenerDatosSesion()
        if(!ses || !ses.id) return
        const usuario = await HttpService.obtenerConConsultas('usuarios.php', { accion: 'obtener_por_id', id: Number(ses.id) })
        if(usuario && usuario.grupoId){
          const grupo = await HttpService.obtenerConConsultas('grupos.php', { accion: 'obtener_por_id', id: Number(usuario.grupoId) })
          if(grupo && grupo.nombre){
            this.grupoNombre = grupo.nombre
          }
        }
      } catch(e){ console.error('No se pudo determinar grupo por defecto', e) }
      // cargar datos aunque no se haya podido determinar nombre
      this.cargarMiembros()
      this.cargarServiciosYAsistencias()
    },
    async cargarMiembros(){
      try{
        const payload = { accion: 'obtener' }
        if(this.grupoSeleccionadoId) payload.grupoSeleccionado = this.grupoSeleccionadoId
        const res = await HttpService.obtenerConConsultas('miembros.php', payload)
        this.miembros = Array.isArray(res) ? res : []
        for(const m of this.miembros){ if(!this.matrix[m.id]) this.matrix[m.id] = {} }
        this.generarDiasMes()
        this.initMatrixMonthly()
      } catch(e){ console.error(e) }
    },
    async cargarServiciosYAsistencias(){
      if(!this.grupoNombre) return
      try{
        const prefix = this.fecha.substr(0, 8)
        const serviciosDia = {}
        const asistenciasDia = {}

        this.generarDiasMes()
        this.initMatrixMonthly()

        const consultas = this.diasMes.map(async d => {
          const fechaDia = `${prefix}${String(d.day).padStart(2, '0')}`
          const payloadServicios = { accion: 'servicios_por_fecha', fecha: fechaDia }
          const payloadAsistencia = { accion: 'obtener', fecha: fechaDia }
          if(this.grupoSeleccionadoId){
            payloadServicios.grupoSeleccionado = this.grupoSeleccionadoId
            payloadAsistencia.grupoSeleccionado = this.grupoSeleccionadoId
          }
          const [serv, asist] = await Promise.all([
            HttpService.obtenerConConsultas('asistencias.php', payloadServicios),
            HttpService.obtenerConConsultas('asistencias.php', payloadAsistencia)
          ])
          if(serv && serv.error) throw new Error(serv.error)
          if(asist && asist.error) throw new Error(asist.error)
          serviciosDia[d.day] = Array.isArray(serv) ? serv : []
          asistenciasDia[d.day] = Array.isArray(asist) ? asist : []
        })

        await Promise.all(consultas)

        this.servicesByDay = serviciosDia

        for(const m of this.miembros){
          if(!this.matrixMonthly[m.id]) this.matrixMonthly[m.id] = {}
          for(const d of this.diasMes){
            this.matrixMonthly[m.id][d.day] = [0,0,0]
          }
        }

        let hayAsistenciaGuardada = false
        for(const d of this.diasMes){
          const slots = this.slotsForDay(d)
          const registros = asistenciasDia[d.day] || []
          if(registros.length) hayAsistenciaGuardada = true
          for(const a of registros){
            const idx = slots.findIndex(s => Number(s.serviceId) === Number(a.servicioId))
            if(idx >= 0 && this.matrixMonthly[a.miembroId] && this.matrixMonthly[a.miembroId][d.day]){
              this.matrixMonthly[a.miembroId][d.day][idx] = a.presente ? 1 : 0
            }
          }
        }

        this.isEditMode = !hayAsistenciaGuardada
        this.lastSavedSnapshot = JSON.stringify(this.matrixMonthly)
        this.isDirty = false
      } catch(e){ console.error(e) }
    },
    marcarTodos(servicioId){
      for(const m of this.miembros){ if(this.matrix[m.id] && this.matrix[m.id][servicioId]) this.matrix[m.id][servicioId].presente = 1 }
    },
    generarDiasMes(){
      const [y, mo] = this.fecha.split('-').map(Number)
      const year = y || new Date().getFullYear()
      const month = mo ? mo - 1 : new Date().getMonth()
      const num = new Date(year, month + 1, 0).getDate()
      const arr = []
      const nombres = ['Domingo','Lunes','Martes','Miércoles','Jueves','Viernes','Sábado']
      for(let i=1;i<=num;i++){
        const ts = new Date(year, month, i)
        const dow = ts.getDay() // 0-6
        const nombre = nombres[dow]
        arr.push({ day: i, dow, nombre })
      }
      this.diasMes = arr
      this.initMatrixMonthly()
    },
    initMatrixMonthly(){
      for(const m of this.miembros){ 
        if(!this.matrixMonthly[m.id]) this.matrixMonthly[m.id] = {};
        for(const d of this.diasMes){ 
          if(typeof this.matrixMonthly[m.id][d.day] === 'undefined') this.matrixMonthly[m.id][d.day] = [0,0,0]
          // ensure length 3
          if(!Array.isArray(this.matrixMonthly[m.id][d.day])) this.matrixMonthly[m.id][d.day] = [0,0,0]
          while(this.matrixMonthly[m.id][d.day].length < 3) this.matrixMonthly[m.id][d.day].push(0)
        }
      }
    },
    onCheckboxChange(){
      this.resumenVersion += 1
      this.isDirty = JSON.stringify(this.matrixMonthly) !== this.lastSavedSnapshot
    },
    activarEdicion(){
      this.isEditMode = true
    },
    formatCounter(counter){
      if(!counter) return '0 de 0'
      return `${counter.attended} de ${counter.possible}`
    },
    isSlotPresent(miembroId, day, idx){
      return !!(this.matrixMonthly[miembroId] && this.matrixMonthly[miembroId][day] && this.matrixMonthly[miembroId][day][idx])
    },
    isSlotEdited(miembroId, day, idx){
      const actual = this.matrixMonthly[miembroId] && this.matrixMonthly[miembroId][day]
        ? Number(this.matrixMonthly[miembroId][day][idx] ? 1 : 0)
        : 0
      const previo = this.snapshotMatrix[miembroId] && this.snapshotMatrix[miembroId][day]
        ? Number(this.snapshotMatrix[miembroId][day][idx] ? 1 : 0)
        : 0
      return actual !== previo
    },
    slotCategory(slot){
      if(!slot || slot.disabled || !slot.hora) return null
      const hora = String(slot.hora).trim()
      const label = String(slot.label || '').toLowerCase()
      if(hora === '07:00' || label.includes('dominical')) return 'dominical7'
      if(hora === '18:00' || label.includes('especial')) return 'especial'
      if(hora === '05:00') return 'oracion5'
      if(hora === '09:00') return 'oracion9'
      if(hora === '19:00') return 'oracion19'
      return null
    },
    showQuickToast(message, type = 'is-success'){
      if(this.$buefy && this.$buefy.toast){
        this.$buefy.toast.open({
          message,
          type,
          position: 'is-bottom',
          duration: 1400,
          queue: false
        })
        return
      }
      // Fallback mínimo si Buefy no está disponible.
      console.log(message)
    },
    exportarExcel(){
      const safe = (val) => {
        const text = String(val == null ? '' : val)
        return '"' + text.replace(/"/g, '""') + '"'
      }
      const ym = (this.fecha || '').slice(0,7)
      const group = this.grupoNombre || 'grupo'
      const lines = []

      lines.push([`Control de asistencia mensual`, `${this.monthTitle}`, `Grupo: ${group}`].map(safe).join(';'))
      lines.push('')

      lines.push([
        'Resumen general',
        'Asistidas',
        'Posibles'
      ].map(safe).join(';'))
      for(const item of this.resumenGeneralItems){
        lines.push([
          item.label,
          item.attended,
          item.possible
        ].map(safe).join(';'))
      }

      lines.push('')
      lines.push([
        'Miembro',
        '5:00 Asistidas', '5:00 Posibles',
        '9:00 Asistidas', '9:00 Posibles',
        '19:00 Asistidas', '19:00 Posibles',
        'Especial Asistidas', 'Especial Posibles',
        'Dominical 7:00 Asistidas', 'Dominical 7:00 Posibles',
        'Total Asistidas', 'Total Posibles'
      ].map(safe).join(';'))

      for(const r of this.resumenPorMiembro){
        lines.push([
          r.nombre,
          r.oracion5.attended, r.oracion5.possible,
          r.oracion9.attended, r.oracion9.possible,
          r.oracion19.attended, r.oracion19.possible,
          r.especial.attended, r.especial.possible,
          r.dominical7.attended, r.dominical7.possible,
          r.total.attended, r.total.possible
        ].map(safe).join(';'))
      }

      lines.push('')
      lines.push([safe('Detalle por casilla (igual a la tabla de asistencia)')].join(';'))

      const [yearRaw, monthRaw] = (this.fecha || '').split('-').map(Number)
      const exportYear = yearRaw || new Date().getFullYear()
      const exportMonth = monthRaw || (new Date().getMonth() + 1)

      const dayHeaderRow = ['Miembro']
      const slotHeaderRow = ['Miembro']
      const detalleSlots = []

      for(const d of this.diasMes){
        const slots = this.slotsForDay(d).filter(s => s && !s.disabled)
        if(!slots.length) continue

        const fechaLabel = `${String(d.day).padStart(2, '0')}/${String(exportMonth).padStart(2, '0')}/${exportYear}`
        const dayLabel = `${String(d.nombre || '').toUpperCase()} ${fechaLabel}`

        for(let i = 0; i < slots.length; i++){
          const slot = slots[i]
          dayHeaderRow.push(i === 0 ? dayLabel : '')

          const categoria = this.slotCategory(slot)
          let servicioLabel = 'Oración'
          if(categoria === 'especial') servicioLabel = 'Servicio especial'
          else if(categoria === 'dominical7') servicioLabel = 'Dominical'
          slotHeaderRow.push(`${slot.hora} ${servicioLabel}`)

          const realIdx = this.slotsForDay(d).findIndex(s => s && s.hora === slot.hora && s.label === slot.label)
          detalleSlots.push({ day: d.day, idx: realIdx >= 0 ? realIdx : i })
        }
      }

      lines.push(dayHeaderRow.map(safe).join(';'))
      lines.push(slotHeaderRow.map(safe).join(';'))

      for(const m of this.miembros){
        const row = [m.nombre]
        for(const ds of detalleSlots){
          const marcado = this.matrixMonthly[m.id] && this.matrixMonthly[m.id][ds.day]
            ? Number(this.matrixMonthly[m.id][ds.day][ds.idx] ? 1 : 0)
            : 0
          row.push(marcado ? '✓' : '')
        }
        lines.push(row.map(safe).join(';'))
      }

      const csv = '\uFEFF' + lines.join('\n')
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = `asistencia_${group.replace(/\s+/g, '_')}_${ym}.csv`
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      URL.revokeObjectURL(url)
      this.showQuickToast('Archivo exportado')
    },
    async guardarMensual(){
      if(!this.miembros.length){
        alert('No hay miembros para guardar asistencia.')
        return
      }
      this.isSaving = true
      try{
        const prefix = this.fecha.substr(0,8)
        let previous = {}
        try{ previous = this.lastSavedSnapshot ? JSON.parse(this.lastSavedSnapshot) : {} } catch(_e){ previous = {} }

        const registros = []
        for(const d of this.diasMes){
          const fechaDia = `${prefix}${String(d.day).padStart(2, '0')}`
          const slots = this.slotsForDay(d)
          for(const m of this.miembros){
            for(let i = 0; i < slots.length; i++){
              const slot = slots[i]
              if(slot.disabled || !slot.serviceId) continue

              const actual = this.matrixMonthly[m.id] && this.matrixMonthly[m.id][d.day]
                ? Number(this.matrixMonthly[m.id][d.day][i] ? 1 : 0)
                : 0
              const anterior = previous[m.id] && previous[m.id][d.day]
                ? Number(previous[m.id][d.day][i] ? 1 : 0)
                : 0

              if(actual === anterior) continue

              registros.push({
                miembroId: m.id,
                servicioId: slot.serviceId,
                presente: actual,
                nota: '',
                fecha: fechaDia
              })
            }
          }
        }

        if(!registros.length){
          this.isDirty = false
          this.isEditMode = false
          alert('No hay cambios por guardar.')
          return
        }

        const payloadGuardar = {
          accion: 'registrar_bulk',
          fecha: this.fecha,
          registros
        }
        if(this.grupoSeleccionadoId) payloadGuardar.grupoSeleccionado = this.grupoSeleccionadoId
        const res = await HttpService.registrar('asistencias.php', payloadGuardar)
        const raw = typeof res === 'string' ? res.trim().toLowerCase() : res
        const confirmado = (
          res === true ||
          res === 1 ||
          res === '1' ||
          raw === 'true' ||
          raw === '1'
        )

        if(res && typeof res === 'object' && res.error) throw new Error(res.error)
        if(!confirmado){
          throw new Error('El backend no confirmó el guardado. Respuesta: ' + JSON.stringify(res))
        }

        this.lastSavedSnapshot = JSON.stringify(this.matrixMonthly)
        this.isDirty = false
        this.isEditMode = false
        this.showQuickToast('Asistencia guardada')
      } catch(e){
        console.error(e)
        alert('No se pudo guardar la asistencia. ' + (e && e.message ? e.message : ''))
      } finally {
        this.isSaving = false
      }
    },
    slotsForDay(dayRecord){
      const base = this.slotsBaseForDay(dayRecord.dow)
      if(!dayRecord || !this.servicesByDay[dayRecord.day]) return base

      const serviciosDelDia = this.servicesByDay[dayRecord.day]
      return base.map(slot => {
        if(slot.disabled || !slot.hora) return { ...slot, serviceId: null }
        const service = serviciosDelDia.find(s => (s.hora || '').trim() === slot.hora)
        if(!service) return { ...slot, disabled: true, serviceId: null }
        return { ...slot, label: service.nombre || slot.label, serviceId: service.id }
      })
    },
    slotsBaseForDay(dow){
      if(dow === 0){
        return [
          { label: '7:00 dominical', hora: '07:00', disabled: false },
          { label: '—', hora: '', disabled: true },
          { label: 'Servicio especial', hora: '18:00', disabled: false }
        ]
      }
      if(dow === 4){
        return [
          { label: 'Oración', hora: '05:00', disabled: false },
          { label: 'Oración', hora: '09:00', disabled: false },
          { label: 'Servicio especial', hora: '18:00', disabled: false }
        ]
      }
      return [
        { label: 'Oración', hora: '05:00', disabled: false },
        { label: 'Oración', hora: '09:00', disabled: false },
        { label: 'Oración', hora: '19:00', disabled: false }
      ]
    },
    async guardar(){
      const registros = []
      for(const m of this.miembros){
        const row = this.matrix[m.id] || {}
        for(const s of this.servicios){
          const cell = row[s.id] || { presente:0, nota: '' }
          registros.push({ miembroId: m.id, servicioId: s.id, presente: Number(cell.presente), nota: cell.nota })
        }
      }
      try{
        const payload = { accion: 'registrar_bulk', fecha: this.fecha, registros }
        const res = await HttpService.registrar('asistencias.php', payload)
        if(res === true || res == 1) this.cargarServiciosYAsistencias()
        else alert('Error al guardar')
      } catch(e){ console.error(e); alert('Error en la petición') }
    }
  }
}
</script>

<style scoped>
.box{ padding:1rem }
.main-control{
  padding:1.5rem;
  max-width:1400px;
  width:100%;
  margin:0 auto;
  box-sizing:border-box;
  font-size:15px;
}
.table.is-fullwidth.is-striped.is-narrow{ overflow:auto; }
.table td, .table th{ vertical-align: middle; padding: .5rem .75rem; }
.slot-box{ min-width:110px; min-height:72px; display:flex; flex-direction:column; justify-content:center; align-items:center; gap:6px; }
.asistencia-check{
  -webkit-appearance: none;
  appearance: none;
  width: 14px;
  height: 14px;
  border: 1.5px solid #8fae99;
  border-radius: 4px;
  background: #fff;
  display: inline-grid;
  place-content: center;
  cursor: pointer;
  margin-bottom: 4px;
  transition: background-color .14s ease, border-color .14s ease, transform .14s ease;
}
.asistencia-check::before{
  content: '';
  width: 8px;
  height: 8px;
  transform: scale(0);
  transition: transform .12s ease;
  clip-path: polygon(14% 44%, 0 59%, 45% 100%, 100% 20%, 84% 6%, 43% 72%);
  background: #fff;
}
.asistencia-check:checked{
  background: #166534;
  border-color: #166534;
}
.asistencia-check:checked::before{ transform: scale(1); }
.asistencia-check:disabled{ cursor: not-allowed; opacity: .92; }
.asistencia-check:checked:disabled{
  background: #166534;
  border-color: #166534;
  opacity: 1;
}
.slot-box.is-present{
  border-color:#b8e7cc !important;
  background: linear-gradient(180deg,#f3fff8,#e8f9f0) !important;
  box-shadow: 0 3px 10px rgba(31, 143, 77, 0.14);
}
.slot-box.is-present .slot-hora,
.slot-box.is-present .slot-label{ color:#17673a; }
.slot-box.is-edited{
  border-color:#f0cf7c !important;
  background: linear-gradient(180deg,#fff8df,#fff1bf) !important;
  box-shadow: 0 3px 10px rgba(200, 148, 22, 0.18);
}
.slot-box.is-edited .slot-hora,
.slot-box.is-edited .slot-label{ color:#8a6408; }
.asistencia-check.is-edited-check{
  border-color: #c19313;
}
.asistencia-check.is-edited-check:checked{
  background: #c19313;
  border-color: #c19313;
}
.slot-label{ font-size:12px; }
.slot-hora{ font-size:11px; color:#666; }
@media (max-width:900px){ .main-control{ padding:1rem; } .slot-box{ min-width:80px; } }

/* Sticky header and first column for monthly table (title fixed outside scroll area) */
.table-scroll{ overflow:auto; max-height:72vh; }
.month-title{ position:relative; display:block; background: linear-gradient(180deg,#ffffff,#fafafa); z-index:1; text-align:center; padding:12px 12px; font-weight:700; border-bottom:1px solid #e6e6e6; font-size:1.05rem; }
.monthly-table thead th{ position:sticky; top:0; background: #fff; z-index:6; }
.monthly-table thead th:first-child{ left:0; z-index:7; }
.monthly-table tbody td:first-child{ position:sticky; left:0; background:#fff; z-index:5; }
.monthly-table thead th:first-child{ position:sticky; left:0; top:0; }
.monthly-table th, .monthly-table td{ white-space: nowrap; }

/* Diferenciación de días */
.monthly-table th.dia-domingo, .monthly-table td.dia-domingo{ background: #fff6f6 !important; }
.monthly-table th.dia-jueves, .monthly-table td.dia-jueves{ background: #f6fbff !important; }
.monthly-table th.dia-par, .monthly-table td.dia-par{ background: #fbfbfb; }
.monthly-table td:hover{ background: #f0f6ff; }
.monthly-table thead th{ border-bottom:2px solid #eee }
.monthly-table tbody td{ border-right:1px solid #f0f0f0 }

/* Centrar encabezados y celdas de días (excepto la primera columna 'Miembro') */
.monthly-table th:not(:first-child), .monthly-table td:not(:first-child){
  text-align: center;
  vertical-align: middle;
}
.monthly-table thead th{ text-align:center }
.monthly-table thead th:first-child, .monthly-table tbody td:first-child{ text-align:left }
.monthly-table thead th small{ display:block; font-size:0.85em; color:#666 }

/* Modern look: sombras, degradados y micro-animaciones por columna */
.monthly-table td .slot-box{ background: linear-gradient(180deg,#ffffff,#fafafa); border-radius:8px; box-shadow:0 2px 6px rgba(16,24,40,0.06); transition:transform .14s ease, box-shadow .14s ease, background .14s ease; padding:8px; }
.monthly-table td:hover .slot-box{ transform:translateY(-4px); box-shadow:0 10px 24px rgba(16,24,40,0.10); }

.monthly-table td.dia-domingo .slot-box{ background: linear-gradient(180deg,#fff6f6,#ffecec); }
.monthly-table td.dia-jueves .slot-box{ background: linear-gradient(180deg,#f6fbff,#eaf6ff); }
.monthly-table td.dia-par .slot-box{ background: linear-gradient(180deg,#ffffff,#fbfbfb); }

.monthly-table thead th.dia-domingo{ background: linear-gradient(180deg,#fff6f6,#fff0f0) !important }
.monthly-table thead th.dia-jueves{ background: linear-gradient(180deg,#f6fbff,#eaf6ff) !important }
.monthly-table thead th.dia-par{ background: linear-gradient(180deg,#ffffff,#fbfbfb) !important }

.member-name-cell{
  max-width: 180px;
}
.member-name-text{
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  white-space: normal;
  word-break: break-word;
  line-height: 1.1;
}

.resumen-general-grid{
  margin: 12px 0 14px 0;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 10px;
}
.resumen-card{
  border: 1px solid #ececec;
  border-radius: 10px;
  padding: 10px 12px;
  background: linear-gradient(180deg,#ffffff,#fafcff);
  box-shadow: 0 4px 10px rgba(10, 25, 46, 0.04);
}
.resumen-card-label{ color:#5b6472; font-size:.82rem; }
.resumen-card-value{ color:#1b2430; font-weight:700; font-size:1rem; margin-top:2px; }
.resumen-card-value small{ color:#6b7280; font-weight:500; font-size:.8rem; }

.resumen-miembros-wrap{ margin-top: 14px; }
.resumen-miembros-title{ margin-bottom: 8px; }
.resumen-miembros-table thead th{ background:#f8fafc; font-size:.8rem; }
.resumen-miembros-table tbody td{ font-size:.88rem; vertical-align: middle; }

.mobile-fab-actions{ display:none; }

@media (max-width: 900px){
  .resumen-miembros-table{ font-size:.82rem; }
}

@media (max-width: 768px){
  .desktop-action-row{ display:none; }
  .main-control{
    padding: .65rem;
    font-size: 13px;
  }
  .month-title{
    padding: 8px;
    font-size: .95rem;
  }
  .table-scroll{
    max-height: 58vh;
  }
  .monthly-table th,
  .monthly-table td{
    padding: .22rem .28rem;
  }
  .monthly-table thead th{
    font-size: .74rem;
  }
  .monthly-table thead th small{
    display: none;
  }
  .monthly-table thead th:first-child,
  .monthly-table tbody td:first-child{
    min-width: 92px;
    max-width: 92px;
  }
  .member-name-cell{
    max-width: 88px;
    min-width: 88px;
    vertical-align: middle;
    padding-top: .18rem;
    padding-bottom: .18rem;
  }
  .member-name-text{
    font-size: .72rem;
    line-height: 1.05;
    -webkit-line-clamp: 3;
  }
  .slot-box{
    min-width: 52px;
    min-height: 42px;
    border-radius: 6px;
    box-shadow: none;
    background: #fff;
    padding: 4px;
    gap: 2px;
  }
  .slot-box.is-present{
    border-color:#9fd8b7 !important;
    background: linear-gradient(180deg,#ecfff4,#dff7eb) !important;
    box-shadow: none;
  }
  .slot-box.is-edited{
    border-color:#e7c46c !important;
    background: linear-gradient(180deg,#fff6d8,#ffeeb5) !important;
    box-shadow: none;
  }
  .asistencia-check{
    width: 13px;
    height: 13px;
    margin-bottom: 0;
  }
  .asistencia-check::before{
    width: 7px;
    height: 7px;
  }
  .slot-label{
    display: none;
  }
  .slot-hora{
    font-size: .62rem;
    line-height: 1;
    color: #7a7a7a;
  }
  .monthly-table td:hover .slot-box{
    transform: none;
    box-shadow: none;
  }
  .mobile-fab-actions{
    display:flex;
    position: fixed;
    right: 8px;
    bottom: calc(8px + env(safe-area-inset-bottom));
    z-index: 220;
  }
  .mobile-fab-button{
    height: 26px !important;
    min-height: 26px !important;
    font-size: .64rem !important;
    font-weight: 600;
    line-height: 1 !important;
    letter-spacing: .01em;
    border-radius: 999px !important;
    border: 1px solid rgba(255,255,255,0.55) !important;
    box-shadow: 0 6px 12px rgba(15, 23, 42, 0.14);
    padding: 0 .52rem !important;
    min-width: auto !important;
    opacity: .97;
    backdrop-filter: blur(4px);
    transition: transform .16s ease, box-shadow .16s ease, opacity .16s ease;
  }
  .mobile-fab-actions .button.is-primary.mobile-fab-button,
  .mobile-fab-actions .button.is-info.mobile-fab-button{
    background-color: #2f80ed !important;
    border-color: #2f80ed !important;
    color: #fff !important;
  }
  .mobile-fab-button:hover,
  .mobile-fab-button:focus{
    transform: translateY(-1px);
    box-shadow: 0 10px 20px rgba(15, 23, 42, 0.16);
    opacity: 1;
  }
  .mobile-fab-button:active{
    transform: translateY(0);
  }
  .box.main-control{
    padding-bottom: 52px;
  }
}
</style>
